/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Activity_Bar_Error_OtherInputs */



/**
* | output |
* | --- |
* | "{count} items failed" |
*
* @param {Activity_Bar_Error_OtherInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_bar_error_other = /** @type {((inputs: Activity_Bar_Error_OtherInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Bar_Error_OtherInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Elemente fehlgeschlagen`)
	return /** @type {LocalizedString} */ (`${i?.count} items failed`)
});